function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.243 25.009l-5.049-5.049a8.819 8.819 0 002.006-5.61 8.85 8.85 0 10-17.7 0 8.85 8.85 0 008.85 8.85c2.13 0 4.08-.75 5.606-2.001l5.048 5.044a.874.874 0 001.239-1.234zm-11.893-3.57c-3.913 0-7.093-3.18-7.093-7.089 0-3.909 3.18-7.093 7.093-7.093 3.909 0 7.093 3.184 7.093 7.093s-3.184 7.089-7.093 7.089z",
  fill: "#000",
  fillRule: "nonzero"
});

var SvgIcListSearchActive = function SvgIcListSearchActive(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "0b26d74fdfb00f7521682a2dced011ba.svg";
export { SvgIcListSearchActive as ReactComponent };